import { Component, OnInit } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { Page, PageLevel, PageType, SiteEditorConfig } from '@urbannex/kwikstore-visual-editor/src/lib/editor-container/editor-model';
import { BannerGridFullAComponent, BannerGridFullBComponent } from '@urbannex/storethemes';

@Component({
  selector: 'pl-root',
  template: `<router-outlet></router-outlet>`,
  styles:[':host { height: 100vh;display: block;overflow: hidden;}']
})
export class AppComponent implements OnInit {
  
  title = 'editor-playground';

  constructor(private themeService:NbThemeService){

  }
 
  ngOnInit(): void {
    this.themeService.changeTheme('default');
    console.log(this.themeService.currentTheme);
  }

}
